import { Component, Directive, OnInit } from '@angular/core';
import { AlertComponent } from '../alert/alert.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Router } from "@angular/router";
import { EnumPage} from '../../utils/common.enum';

/**
 * 培训考核系统基类
 */
@Component({
    template: ''
})
export class StudyBase implements OnInit {
    bsModalRef: BsModalRef;
    loading = false;            //是否显示Loading标志位

    constructor(
        public modalService: BsModalService, public router: Router
    ) {


    }

    ngOnInit() {

    }

    /**
     * 弹窗提示 
     * @param alertTitle      标题
     * @param alertContent    提示消息
     * @param confirmButtonShowFlag   是否显示【确定】按钮的标志位 
     */
    alert(alertTitle: string, alertContent: string, confirmButtonShowFlag: boolean) {
        const initialState = {
            title: alertTitle,
            content: alertContent,
            confirmButtonShowFlag: confirmButtonShowFlag
        };
        // 显示弹框
        this.bsModalRef = this.modalService.show(AlertComponent, { initialState });
        // 子组件关闭后，触发的订阅函数
        this.modalService.onHidden.subscribe(() => {
            console.log('title', this.bsModalRef.content.title);
        });
    }

    /**
     * 跳回 登录页
     * @param enumReenterPageType 需要重新进入的页面枚举类型 
     */
    backLogin(enumReenterPageType: EnumPage = EnumPage.Login) {

        let msg: string = null;
        if (enumReenterPageType == EnumPage.Login) {
            msg = "页面已过期，请重新登录。";
        }else if(enumReenterPageType == EnumPage.Register){
            msg = "页面已过期，请重新进入注册页面。";
        }else if(enumReenterPageType == EnumPage.FindPassword){
            msg = "页面已过期，请重新进入密码找回页面。";
        }
        this.alert("提示",msg,false);
        //跳转到登录页
        this.router.navigateByUrl("/login");
    }

}
